import React from "react";
import { api, errMsg } from "@/lib/api";
import { downloadBlob } from "@/lib/download";
import AuthImage from "@/components/AuthImage";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Download, Trash2, Cake } from "lucide-react";
import { toast } from "sonner";

export default function Gallery({ fliers, officer, onChanged }) {
  const remove = async (f) => {
    if (!window.confirm(`Delete the flier for ${f.name}?`)) return;
    try { await api.delete(`/fliers/${f.id}`); toast.success("Flier deleted"); onChanged(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!fliers.length) {
    return (
      <Card className="gold-ring glass p-10 text-center" data-testid="fliers-empty">
        <Cake className="mx-auto h-10 w-10 text-[hsl(var(--gold))]" />
        <h3 className="mt-3 font-display text-xl font-700">No fliers yet</h3>
        <p className="mt-1 text-sm text-muted-foreground">{officer ? "Upload a template, then compose the first birthday flier." : "Birthday fliers composed by the officers will appear here."}</p>
      </Card>
    );
  }
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-3" data-testid="fliers-gallery">
      {fliers.map((f) => (
        <Card key={f.id} className="gold-ring glass group overflow-hidden" data-testid={`flier-card-${f.id}`}>
          <div className="relative aspect-square bg-black/20">
            <AuthImage src={`/fliers/${f.id}/image`} alt={`Birthday flier for ${f.name}`} className="h-full w-full object-contain transition-transform duration-500 group-hover:scale-[1.02]" />
          </div>
          <div className="flex items-center gap-3 p-4">
            <div className="min-w-0 flex-1">
              <p className="truncate font-display text-base font-700" data-testid={`flier-name-${f.id}`}>{f.name}{f.auto && <span className="ml-2 rounded-full bg-[hsl(var(--gold))]/15 px-2 py-0.5 align-middle text-[0.6rem] font-700 uppercase tracking-wider text-[hsl(var(--gold))]" data-testid={`flier-auto-${f.id}`}>Autopilot</span>}</p>
              <p className="truncate text-xs text-muted-foreground">{f.date_text || "Birthday"} · {f.template_name} · by {f.created_by}</p>
            </div>
            <Button size="icon" variant="outline" className="gold-ring h-9 w-9" onClick={() => downloadBlob(`/fliers/${f.id}/image`, `birthday-${f.name.replace(/\s+/g, "-")}.png`)} data-testid={`flier-download-${f.id}`}><Download className="h-4 w-4" /></Button>
            {officer && <Button size="icon" variant="ghost" className="h-9 w-9 text-destructive" onClick={() => remove(f)} data-testid={`flier-delete-${f.id}`}><Trash2 className="h-4 w-4" /></Button>}
          </div>
        </Card>
      ))}
    </div>
  );
}
